// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const clefairy: PokeData = {
  "id": 35,
  "name": "clefairy",
  "height": 6,
  "weight": 75,
  "base_experience": 113,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "tackle",
    "body-slam",
    "double-edge",
    "growl",
    "sing",
    "psychic",
    "minimize",
    "defense-curl",
    "light-screen",
    "metronome",
    "amnesia",
    "splash",
    "sweet-kiss",
    "charm",
    "encore",
    "moonlight",
    "follow-me",
    "meteor-mash",
    "cosmic-power",
    "calm-mind",
    "gravity",
    "wake-up-slap",
    "healing-wish",
    "lucky-chant",
    "copycat",
    "after-you",
    "stored-power",
    "bestow",
    "disarming-voice",
    "draining-kiss",
    "fairy-wind",
    "moonblast",
    "baby-doll-eyes",
    "spotlight",
    "life-dew"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "growl",
    "psychic",
    "splash",
    "sweet-kiss",
    "moonlight",
    "meteor-mash",
    "calm-mind",
    "healing-wish",
    "moonblast",
    "life-dew",
    "hyper-voice"
  ],
  "evolution_chain": {
    "id": 14,
    "item": null,
    "species": [
      {
        "name": "cleffa",
        "order": 36,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "clefairy",
        "order": 37,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 173,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "clefable",
        "order": 38,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 35,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "moon-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 63.25,
    "speed": 35,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
